import React from 'react';
import styled from 'styled-components';
import CloseButton from 'components/CloseButton';
import TransitionElement from './TransitionElement';

interface Props {
  timeout: number,
  onClick: () => void,
}

const TransitionedCloseButton: React.FC<Props> = ({
  timeout,
  onClick,
}) => (
  <TransitionedCloseButtonOuter timeout={timeout}>
    <Inner onClick={onClick}>
      <CloseButton onClick={() => {}} />
    </Inner>
  </TransitionedCloseButtonOuter>
);

const TransitionedCloseButtonOuter = styled.div<{ timeout: number }>`
  position: fixed;
  top: 15px;
  right: 15px;
  transform: scale(0);
  z-index: 4;
  transition-property: transform, opacity;
  transition-duration: ${(p) => p.timeout}ms;
  transition-delay: ${(p) => p.timeout * 1.7}ms;
  ${TransitionElement}.enter &,
  ${TransitionElement}.exit &,
  ${TransitionElement}.exit-done & {
    transition-delay: 0ms;
    transform: scale(0);
    opacity: 0;
  }
  ${TransitionElement}.enter-done & {
    transform: scale(1);
    opacity: 1;
  }
`;

const Inner = styled.div`
  /* box-sizing: border-box; */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  width: 1.5em;
  height: 1.5em;
  background-color: ${(p) => p.theme.palette.interactive};
  color: ${(p) => p.theme.palette.primary};
  border: 3px solid ${(p) => p.theme.palette.primary};
  border-radius: 50%;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.1);
  }
`;

export default TransitionedCloseButton;
